import React from 'react';
import { AuthContextProvider } from './auth/AutoContextProvider';
import RouterComponent from './RouterComponent';


const App = props => {
    return (
      <>
        <AuthContextProvider>
           <RouterComponent/>
        </AuthContextProvider>
      </>
    )
}

export default App